<div style="height: inherit">
    <div style="padding: 0%; display: contents; height: inherit" class="col-md-12 action-buttons text-right">
        <button style="width: 50%" [disabled]="disableGeneratingButton" (click)="generateActivationCode()" class="btn btn-primary">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
    </div>
</div>